define.alias("shared/components/shared/social/tiktok-connection-status", "media/components/shared/social/tiktok-connection-status");